import AlgoliaService from '@/services/AlgoliaService'

export function useSearchService() {
  return AlgoliaService
}
